import './Header.scss';

function Header() {
    return (
        <header className="header">
            <div className="container">
                <div className="header__wrapper">
                    <a href="https://www.klipsch.com/">
                        <img className="pic-Klipsch" src="/img/Klipsch.svg" alt="Klipsch"></img>
                    </a>
                    <a  class="watch-video-review" href="https://www.youtube.com/watch?v=mHjPjLQXoqA">
                        <img className="pic-video" src="/img/pic-video.svg" alt="Смотреть обзор"></img>
                        Смотреть обзор
                    </a>
                    <div class="read-review">
                        <a href="https://www.pult.ru/articles/domashnie-kinoteatry/saundbary-klipsch-novye-gorizonty-kino-i-muzyki/">
                            Читать обзор
                        </a>
                    </div>
                </div> 
                <div className='header-text'>
                    <p className='header-title'>Саундбары</p>
                    <p className='header-subtitle'>Саундбары Klipsch мирового класса, созданные с использованием фирменных технологий, которые обладают превосходным звуком.</p>
                </div>
            </div>
        </header>
    )
}
export default Header;
